__turbopack_context__.v({
  "authForm": "page-module___8aEwW__authForm",
  "cardDesc": "page-module___8aEwW__cardDesc",
  "cardTitle": "page-module___8aEwW__cardTitle",
  "cardsGrid": "page-module___8aEwW__cardsGrid",
  "digital": "page-module___8aEwW__digital",
  "event": "page-module___8aEwW__event",
  "featureCard": "page-module___8aEwW__featureCard",
  "featuresHeader": "page-module___8aEwW__featuresHeader",
  "featuresSection": "page-module___8aEwW__featuresSection",
  "featuresSubtitle": "page-module___8aEwW__featuresSubtitle",
  "featuresTitle": "page-module___8aEwW__featuresTitle",
  "header": "page-module___8aEwW__header",
  "hero": "page-module___8aEwW__hero",
  "heroSubtitle": "page-module___8aEwW__heroSubtitle",
  "heroTitle": "page-module___8aEwW__heroTitle",
  "iconBox": "page-module___8aEwW__iconBox",
  "inputField": "page-module___8aEwW__inputField",
  "inputGroup": "page-module___8aEwW__inputGroup",
  "landingContainer": "page-module___8aEwW__landingContainer",
  "langSwitch": "page-module___8aEwW__langSwitch",
  "loginBtn": "page-module___8aEwW__loginBtn",
  "loginIcon": "page-module___8aEwW__loginIcon",
  "loginSwitcher": "page-module___8aEwW__loginSwitcher",
  "logo": "page-module___8aEwW__logo",
  "physical": "page-module___8aEwW__physical",
  "service": "page-module___8aEwW__service",
  "shieldIcon": "page-module___8aEwW__shieldIcon",
  "switcherBtn": "page-module___8aEwW__switcherBtn",
  "switcherBtnActive": "page-module___8aEwW__switcherBtnActive",
});
